import { createFileRoute } from '@tanstack/react-router';
import { McpPlatformOverviewPage } from '@/features/admin/pages/mcp';

export const Route = createFileRoute('/admin/mcp/')({
  component: McpPlatformOverviewPage,
});
